import styled from "styled-components"
import bg from "../../assets/img/timeline/timeline-bg.png"
import { CursorCrosshairWhite } from "shared/Styles/Cursors"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  background: url(${bg}) black center;
  position: relative;
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: calc(100% - 155px);
  margin: unset;
  @media screen and (max-width: ${props=>props.theme.breakpoints.phoneBig}) {
    width: 90%;
    margin: auto;
    padding-top: 80px;
  }
`

export const Text = styled.span`
  font-family: "sharp_groteskmedium_25";
  font-weight: 500;
  text-align: center;
  color: ${props => props.theme.color.white};
  font-size: 10px;
  height: 55px;
  @media screen and (min-width: ${props =>
      props.theme.breakpoints.phoneSmall}) {
    font-size: 13px;
    height: 65px;
  }
  @media screen and (min-width: ${props =>
      props.theme.breakpoints.tabletSmall}) {
    font-size: 17px;
  }
  @media screen and (min-width: ${props =>
      props.theme.breakpoints.laptopSmall}) {
    font-size: 19px;
  }
`

export const Dot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${props => props.theme.color.black};
  position: relative;
  &::before {
    transition: 0.5s width, 0.5s height, 0.5s border;
    content: "";
    display: block;
    width: 1px;
    height: 1px;
    border: 11px solid ${props => props.theme.color.white};
    border-radius: 50%;
    position: absolute;
    transform: translate(calc(-50% + 7px / 2), calc(-50% + 7px / 2));
    z-index: -1;
  }
`

export const Line = styled.div`
  position: absolute;
  width: 90%;
  height: 1px;
  background: white;
  animation: fill 1.5s cubic-bezier(.56,.03,.76,.1);
  animation-fill-mode: forwards;
  transform-origin: left;
  overflow: hidden;
  @keyframes fill {
    from {
      transform: translateY(27px) scaleX(0);
    }
    to {
      transform: translateY(27px) scaleX(1);
    }
  }
  @media screen and (min-width: ${props=>props.theme.breakpoints.phoneBig}) {
    width: calc(100% - 140px);
  }
  @media screen and (min-width: ${props =>
      props.theme.breakpoints.phoneSmall}) {
    transform: translateY(32px);
    @keyframes fill {
      from {
        transform: translateY(32px) scaleX(0);
      }
      to {
        transform: translateY(32px) scaleX(1);
      }
    }
  }
`

export const TimelineElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${CursorCrosshairWhite}
  padding: 50px 6px;
  position: relative;
  z-index: 3;
  opacity: 0;
  animation: fadeIn 0.8s cubic-bezier(.56,.03,.76,.1);
  animation-fill-mode: forwards;
  animation-delay: ${props => props.delay * 200}ms;
  &:hover {
    ${Dot} {
      background-color: ${props => props.theme.color.white};
      &::before {
        width: 40px;
        height: 40px;
        border: 2px solid ${props => props.theme.color.primary};
      }
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
